import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable, Signal } from '@angular/core';
import { ServiceWorkgroupObject } from '@libs/types/src/services/object-type/service/settings/service-workgroup.object';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectCurrentServiceId } from '../../../../store/person/person.selectors';

@Injectable()
export class SelectFolderWorkgroupDialogStore extends ComponentStoreV2Factory {

    public serviceId = toSignal(globalStore!.select(selectCurrentServiceId));

    public workgroupOptions: Signal<ServiceWorkgroupObject[]> = computed(() => {
        return this.data.getServiceWorkgroups()?.['items'] || [];
    })

}
